import type { SVGProps } from "react";

interface PastEventIconProps extends SVGProps<SVGSVGElement> {
  strokeColor?: string;
}

const PastEventIcon = ({
  strokeColor,
  stroke = "currentColor",
  width = 20,
  height = 20,
  ...props
}: PastEventIconProps) => {
  const finalStroke = strokeColor || stroke || "currentColor";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.6667 1.6665H5C4.55797 1.6665 4.13405 1.8421 3.82149 2.15466C3.50893 2.46722 3.33333 2.89114 3.33333 3.33317V16.6665C3.33333 17.1085 3.50893 17.5325 3.82149 17.845C4.13405 18.1576 4.55797 18.3332 5 18.3332H15C15.442 18.3332 15.866 18.1576 16.1785 17.845C16.4911 17.5325 16.6667 17.1085 16.6667 16.6665V6.6665L11.6667 1.6665Z"
        stroke={finalStroke}
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M11.6667 1.6665V6.6665H16.6667"
        stroke={finalStroke}
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M6.66667 10.8335H13.3333M6.66667 14.1668H11.6667"
        stroke={finalStroke}
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PastEventIcon;